import {SiteProviderKind} from "../types/site-provider-kind.type";

export interface SiteProviderTab {
  kind: SiteProviderKind;
  label: string;
}

export const SITE_PROVIDER_TABS: SiteProviderTab[] = [
  {kind: SiteProviderKind.DeliveryTime, label: 'Delivery Time'},
  {kind: SiteProviderKind.ServiceTime, label: 'Service Time'},
  {kind: SiteProviderKind.Units, label: 'Delivery Cases'}
];
